<template>
  <header
    class="px-4 py-12 text-white text-center bg-primary"

  >
    <h1 class="mb-8 text-[28px] leading-[34px] tracking-[0.64px] font-bold md:text-[35px] md:leading-[42px]">
      Donating &pound;{{ amount }} to CARE
      {{ donationType == "once" ? "now" : repetition }}
    </h1>

    <!-- <button>
      update
    </button> -->

    <ul
      v-if="stages"
      :aria-label="'Stage ' + stageNumber + ' of ' + stages"
      class="mt-4"
    >
      <li
        v-for="n in stages"
        :key="n"
        class="inline-block mx-2 rounded-full w-4 h-4 border-white border-2"
        :class="[n == stageNumber ? 'bg-white' : '']"
      />
    </ul>
  </header>
</template>

<script>
export default {
  computed: {
    donationType: function() {
      return this.repetition === "once" ? "once" : "directDebit";
    },
    repetition: function() {
      return this.rawRepetition.toLowerCase();
    }
  },

  data() {
    return {};
  },

  props: {
    amount: {
      type: Number,
      required: true
    },
    rawRepetition: {
      type: String,
      required: false,
      default: "regularly"
    },
    stages: {
      type: Number,
      required: false
    },
    stageNumber: {
      type: Number,
      required: false
    }
  }
};
</script>
